/*
 * The mockup's composer: `.comp-box` (the field and its bar, the box shows the focus),
 * `.comp-bar` (mode, clip, send) and `.comp-foot` (the brief switch and the hint).
 */
.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.box {
  border: 1px solid var(--border-control);
  border-radius: var(--radius-card);
  background: var(--surface-raised);
  transition:
    border-color var(--motion-duration) var(--motion-ease),
    box-shadow var(--motion-duration) var(--motion-ease);
}

/* The measured 2px ring (D-UX-5) plus the mockup's soft halo, on the box around the field. */
.box:has(textarea:focus-visible) {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
  box-shadow: 0 0 0 3px var(--action-soft);
}

.box textarea {
  min-block-size: 64px;
  padding: 10px 12px 4px;
  font-size: var(--font-size-14);
}

.bar {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  padding: 4px 6px 6px;
}

.spacer {
  flex: 1;
}

.attach {
  display: inline-grid;
  place-items: center;
  inline-size: var(--control-height);
  block-size: var(--control-height);
  border-radius: var(--radius-control);
  color: var(--text-muted);
  cursor: pointer;
}

.attach:hover {
  background: var(--state-hover);
  color: var(--text);
}

.attach:focus-within {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.attached {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin: 0 12px;
  color: var(--text-muted);
  font-size: var(--font-size-13);
  overflow-wrap: anywhere;
}

.error {
  margin: 0;
  color: var(--danger-text);
  font-size: var(--font-size-12);
}

.foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.hint {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}
